module.exports = __webpack_public_path__ + "img/jtb-logo-square.c9c10b57.png";